import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IClinicInfo, IClinicMajor, IClinicService } from 'interfaces'
import { RootState } from 'store'

export interface IClinicState {
  services: Array<IClinicService>
  majors: Array<IClinicMajor>
  clinicInfo?: IClinicInfo
  base64Logo?: string
  base64Watermark?: string
}

const initialState: IClinicState = {
  services: [],
  majors: []
}

export const clinicSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setMajorsAction: (
      state: IClinicState,
      action: PayloadAction<Array<IClinicMajor>>
    ) => {
      state.majors = action.payload
    },
    setServicesAction: (
      state: IClinicState,
      action: PayloadAction<Array<IClinicService>>
    ) => {
      state.services = action.payload
    },
    setClinicInfoAction: (
      state: IClinicState,
      action: PayloadAction<IClinicInfo>
    ) => {
      state.clinicInfo = action.payload
    },
    setBase64LogoAction: (
      state: IClinicState,
      action: PayloadAction<string>
    ) => {
      state.base64Logo = action.payload
    },
    setBase64WatermarkAction: (
      state: IClinicState,
      action: PayloadAction<string>
    ) => {
      state.base64Watermark = action.payload
    },
    resetClinicStateAction: () => initialState
  }
})

export const {
  setMajorsAction,
  setServicesAction,
  setClinicInfoAction,
  setBase64LogoAction,
  setBase64WatermarkAction,
  resetClinicStateAction
} = clinicSlice.actions
export const clinicSelector = (state: RootState) => state.clinicReducer
export default clinicSlice.reducer
